/**
 * What a request that charges or refunds scraping credits invalidates (PREC-4456): the balance
 * (`WebsiteScrape`), the source, and its list. Without the balance the confirm dialog and the list
 * wizard keep showing what the company had before the charge or the refund.
 */
export const scrapeCreditTags = (listId?: number) =>
	listId
		? ["WebsiteScrape" as const, { type: "List" as const, id: listId }, "CustomEvent" as const]
		: ["WebsiteScrape" as const, "CustomEvent" as const];
